<template>
  <div class="banner">
    <down @downclickhandler="downClickHandler" />
    <swiper
      :options="swiperOptiona"
      ref="mySwipers"
      class="swiper"
      v-if="list.length"
    >
      <swiper-slide class="item" v-for="(item, index) in list" :key="index">
        <img :src="`http://ys.sansg.com/${item.picurl}`" alt />
        <div class="text">
          <p class="text1" v-show="isShow">{{ item.title }}</p>
          <p class="text2">{{ item.keywords }}</p>
          <p class="text3">{{ item.description }}</p>
        </div>
      </swiper-slide>
    </swiper>
    <div class="line"></div>
    <div class="swiper-pagination" slot="pagination"></div>
    <!-- <div class="btn">
      <div class="prev">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="next">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div> -->
  </div>
</template>

<script>
import Scrollbar from "smooth-scrollbar";
import down from "@/components/down.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    let _this = this;
    return {
      lan: "",
      isShow: true,
      swiperOptiona: {
        slidesPerView: 1,
        effect: "fade",
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          stopOnLastSlide: true,
          delay: 5000,
        },
        pagination: {
          el: ".banner .swiper-pagination",
          clickable: true,
          renderBullet: function(index, className) {
            return (
              '<span class="' + className + '">' + "0" + (index + 1) + "</span>"
            );
          },
        },
        // navigation: {
        //   prevEl: ".banner .btn .prev",
        //   nextEl: ".banner .btn .next",
        // },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
    down,
  },
  props: ["list"],
  mounted(){
    this.getLan();
    this.getShow();
  },
  methods: {
    downClickHandler() {
      this.$emit("downclickhandler");
    },
    gotoAbout() {
      window.open("/about.html", "_blank");
    },
    getLan() {
      this.lan = localStorage.getItem("language");
    },
    getShow() {
      if(this.lan=='zh-CN'){
        this.isShow = true;
      }else{
        this.isShow = false;
      }

    }
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  position: relative;

  .swiper {
    height: 100vh;
    .item {
      position: relative;
      overflow: hidden;
      padding-top: 90px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        z-index: 1;
        cursor: pointer;
        transform: scale(1);
        transition: all 5s;
      }
      .text {
        position: absolute;
        left: 10%;
        width: 80%;
        top: 50%;
        transform: translateY(-50%);
        p {
          color: white;
          opacity: 0;
          transform: translateY(200px);
          transition: all 600ms ease-out;
        }
        p:nth-child(1) {
          font-family: "SOURCEHANSANSCN-BOLD";
          font-size: 70px;
        }
        p:nth-child(2) {
          font-size: 60px;
          font-family: "armt";
          font-weight: bold;
          text-transform: uppercase;
          transition-delay: 200ms;
          position: relative;
          padding-bottom: 40px;
          &::after {
            position: absolute;
            bottom: 0;
            left: 0;
            display: inline-block;
            content: "";
            width: 20%;
            height: 2px;
            background-color: white;
          }
        }
        p:nth-child(3) {
          font-family: "it";
          font-family: "SOURCEHANSANSCN-NORMAL";
          font-size: 30px;
          margin-top: 40px;
          transition-delay: 600ms;
        }
      }
    }
    .swiper-slide-active {
      img {
        transform: scale(1.05);
      }
      .text {
        p {
          opacity: 1;
          transform: translateX(0);
        }
      }
    }
  }
  .btn {
    position: absolute;
    bottom: 5%;
    right: 7%;
    display: flex;
    z-index: 100;
    width: 120px;
    justify-content: space-between;
    .prev {
      width: 40px;
      height: 40px;
      border: 2px solid #ffffff;
      border-radius: 50%;
      position: relative;
      cursor: pointer;
      outline: none;
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
      }
    }
    .next {
      width: 40px;
      height: 40px;
      border: 2px solid #ffffff;
      border-radius: 50%;
      position: relative;
      cursor: pointer;
      outline: none;
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }
  .line {
    display: inline-block;
    content: "";
    position: absolute;
    left: 0px;
    bottom: 100px;
    transform: translateX(-50%);
    background-color: white;
    height: 1px;
    width: 400px;
    z-index: 100;
    opacity: 0.3;
  }
  @media screen and (max-width: 1440px) {
    .swiper {
    }
  }
}
@media screen and (max-width: 1000px) {
  .banner {
    // display: none;
    overflow: hidden;
    .swiper {
      // height: auto;
      .item {
        padding-top: 60px;
        .text {
          top: 52%;
          p:nth-child(1) {
            font-size: 20px;
          }
          p:nth-child(2) {
            font-size: 16px;
            padding-bottom: 10px;
          }
          p:nth-child(3) {
            font-size: 16px;
            margin-top: 10px;
          }
        }
      }
    }
    .line {
      width: 100px;
      bottom: 40px;
    }
    .btn {
      bottom: 30px;
      width: 80px;
      .prev,
      .next {
        width: 20px;
        height: 20px;
        border: 1px solid #ffffff;
        i {
          font-size: 12px;
          font-weight: unset;
        }
      }
    }
  }
}
</style>
<style scoped>
.banner .swiper-pagination {
  position: absolute;
  z-index: 100;
  width: 80%;
  left: 200px;
  bottom: 80px;
  overflow: hidden;
  padding: 10px 0;
  text-align: start;
  padding-left: 5px;
}
@media screen and (max-width: 1000px) {
  .banner .swiper-pagination {
    bottom: 23px;
    left: 80px;
  }
}
.banner .swiper-pagination >>> .swiper-pagination-bullet {
  cursor: pointer;
  background-color: transparent;
  width: auto;
  height: auto;
  font-size: 16px;
  font-family: "DINEngschriftStd";
  margin-right: 30px;
  opacity: 0.3;
  color: white;
  transition: all 600ms;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet-active {
  opacity: 1;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet:focus {
  outline: none;
}
</style>
